import {ButtonSizeBucket, getButtonSizeBucket, LineHeight} from './lineHeightToValue';

/**
 * Returns the IconButton size for row action buttons.
 *
 * Matches the header cell button sizing logic:
 * - Mobile: always 'small' (24 px)
 * - COMPACT / SHORT / DEFAULT row height: 'small' (24 px)
 * - TALL / THUMBNAIL row height: 'default' (32 px)
 */
export function getActionButtonSize(rowHeight: LineHeight, isMobile: boolean): ButtonSizeBucket {
  if (isMobile) {
    return 'small';
  }

  return getButtonSizeBucket(rowHeight);
}
